import { HomePage } from "@/pages/HomePage";

export default function App() {
	return <HomePage />;
}
